import CreatePostPage from '@/components/createPost/Page.vue'
import { isDeviceMobile } from '@/lib/utils'

function createModalProps(props) {
  return {
    parent: this,
    component: CreatePostPage,
    props: {
      isModal: true,
      ...props
    },
    events: {
      close: (platforms) => {
        if (platforms) {
          this.$nuxt.$emit('posts-scheduled', platforms)
        }
      }
    },
    canCancel: false,
    hasModalCard: true,
    destroyOnHide: true,
    fullScreen: isDeviceMobile(),
    width: '85vw',
    customClass: 'create-post-modal'
  }
}

function displayCreatePostModal() {
  this.$buefy.modal.open(createModalProps.call(this, {}))
}

function displayCreatePostModalForMedia(media, createForPlatform = null) {
  this.$buefy.modal.open(
    createModalProps.call(this, { media, createForPlatform })
  )
}

function displayCreatePostModalForPlatform(createForPlatform) {
  this.$buefy.modal.open(createModalProps.call(this, { createForPlatform }))
}

function displayCreatePostModalForAccounts(socialAccounts) {
  this.$buefy.modal.open(createModalProps.call(this, { socialAccounts }))
}

function displayEditPostModal(postId, postPlatform) {
  this.$buefy.modal.open(createModalProps.call(this, { postId, postPlatform }))
}

function displayCreatePostModalFromPost(post) {
  this.$buefy.modal.open(createModalProps.call(this, { fromPost: post }))
}

export default ({ app }, inject) => {
  inject('createPost', displayCreatePostModal)
  inject('createPostForMedia', displayCreatePostModalForMedia)
  inject('createPostForPlatform', displayCreatePostModalForPlatform)
  inject('createPostForAccounts', displayCreatePostModalForAccounts)
  inject('createPostFromPost', displayCreatePostModalFromPost)
  inject('editPost', displayEditPostModal)
}
